import { useContext } from 'react';
import { AuthContext } from 'src/contexts/auth/jwt';

export const useAuth = () => useContext(AuthContext);

export const useUser = () => {
  // To get the user from the authContext, you can use
  const obj = useAuth();
  let user;
  if (obj) {
    user = obj.user;
  }
  if (!user) {
    user = {
      id: 0,
      avatar: '/assets/avatars/avatar-anika-visser.png',
      name: 'Anonymous',
      code: '000000',
    };
  }
  return user;
};

export const useRoles = () => {
  const tenants = [];
  const obj = useAuth();
  if (obj) {
    const roles = obj.roles;
    if (roles) {
      for (const obj of roles) {
        tenants.push(obj.name);
      }
    }
  }
  return tenants;
};

export const useCurrentRole = () => {
  const obj = useAuth();
  if (obj) {
    return obj.currentRole;
  }
  return 'Guest';
};
